// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialShare_root__y6BFQ","modal":"SocialShare_modal__EKsia","content":"SocialShare_content__pLJFp"};